<template functional>
  <div>
    <el-button
      type="text"
      :class="[
        { red: props.column === 'DelayedTasksCount' && props.rowValue > 0 }
      ]"
      @click="$options.OnDetailClick(props, data)"
      >{{
        props.rowValue > 0
          ? props.rowValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : ""
      }}</el-button
    >
    <span v-if="props.column === 'TasksCount' && props.row.TotalHours > 0">
      / {{ props.row.TotalHours }} h</span
    >
    <span
      v-if="props.column === 'DoneTasksCount' && props.row.DoneTaskHours > 0"
    >
      / {{ props.row.DoneTaskHours }} h</span
    >
    <span
      v-if="
        props.column === 'DelayedTasksCount' && props.row.DelayedTasksHours > 0
      "
    >
      / {{ props.row.DelayedTasksHours }} h</span
    >
    <span
      v-if="
        props.column === 'ActualWeekClosedTasksCount' &&
        props.row.ActualWeekClosedTasksHours > 0
      "
    >
      / {{ props.row.ActualWeekClosedTasksHours }} h</span
    >
    <span
      v-if="
        props.column === 'WeekBeforeClosedTasksCount' &&
        props.row.WeekBeforeClosedTasksHours > 0
      "
    >
      / {{ props.row.WeekBeforeClosedTasksHours }} h</span
    >
    <span
      v-if="
        props.column === 'InProgressTasksCount' &&
        props.row.InProgressTasksHours > 0
      "
    >
      / {{ props.row.InProgressTasksHours }} h</span
    >
    <span
      v-if="
        props.column === 'ActualWeekTasksCount' &&
        props.row.ActualWeekTasksHours > 0
      "
    >
      / {{ props.row.ActualWeekTasksHours }} h</span
    >
    <span
      v-if="
        props.column === 'WeekAfterTasksCount' &&
        props.row.WeekAfterTasksHours > 0
      "
    >
      / {{ props.row.WeekAfterTasksHours }} h</span
    >
    <span
      v-if="
        props.column === 'WeekAfterMas1TasksCount' &&
        props.row.WeekAfterMas1TasksHours > 0
      "
    >
      / {{ props.row.WeekAfterMas1TasksHours }} h</span
    >
    <span
      v-if="
        props.column === 'WeekAfterMas2TasksCount' &&
        props.row.WeekAfterMas2TasksHours > 0
      "
    >
      / {{ props.row.WeekAfterMas2TasksHours }} h</span
    >
  </div>
</template>

<script>
export default {
  name: "HyperLinkTasksDetails",

  OnDetailClick(props, data) {
    /*
          Codigos para diferencias los detalles de tareas segun la columna (@TaskCode)
            * TT - Total de Tareas
            * TR - Tareas Realizadas
            * TCSAnt - Tareas Cerradas Semana Anterior
            * TCSAct - Tareas Cerradas Semana Actual
            * TP - Tareas pendientes en progreso
            * TSA - Tareas Semana Actual
            * TSP - Tareas senmana proxima
      */

    data.attrs.OpenTasks(data.attrs.TaskCode, props.row);
  }
};
</script>

<style lang="scss" scoped>
.red {
  color: red !important;
}
</style>
